













































import { Component, Vue, Prop } from 'vue-property-decorator'
import { FormField } from '@/models'
import moment from '@/plugins/moment'

interface DateFieldOptions {
  min ?: number
  max ?: number
  integer ?: boolean
  placeholder ?: string
}

@Component({})
export default class DateField extends Vue {
  /** Current Value */
  @Prop({ type: String }) value !: string
  /** Validation Errors */
  @Prop() errorMessages !: string | string[]
  /** Field Name */
  @Prop({ type: String, required: true }) name !: string
  /** Field Schema */
  @Prop({ type: Object, default: () => ({}) }) schema !: FormField
  /** Disabled state */
  @Prop({ type: Boolean, default: false }) disabled !: boolean

  open = false

  /** Validation Rules */
  get validationRules () {
    const rules = []
        // Required validation
    if (!this.schema.optional) {
      rules.push((v ?: number | null) => !!v || 'Campo Requerido.')
    }
    return rules
  }

  get displayValue () {
    return this.value ? moment(this.value).format('DD-MM-YYYY') : ''
  }

  /** Additional field options */
  get fieldOptions () : DateFieldOptions {
    return this.schema.options || this.schema.fieldOptions || {}
  }

  /** Input event handler */
  handleInput (value : string) {
    this.$emit('input', moment(value).utc().hour(12).toISOString())
    this.open = false
  }
}
